import { render, staticRenderFns } from "./Collapsed.vue?vue&type=template&id=202a0b30&scoped=true"
import script from "./Collapsed.vue?vue&type=script&lang=js"
export * from "./Collapsed.vue?vue&type=script&lang=js"
import style0 from "./Collapsed.vue?vue&type=style&index=0&id=202a0b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202a0b30",
  null
  
)

export default component.exports